// path: src/services/SimuladorService.js
import { trackPromise } from 'react-promise-tracker';
import api from '../utils/API';

/**
 * Como o pedido de bilhete termina: recusa é resultado, não erro, e queda de rede tem situação própria para a tela não dizer "sem acesso" numa falha transitória.
 */
export const SITUACAO_DO_BILHETE = {
  ABERTO: 'aberto',
  SEM_ACESSO: 'semAcesso',
  INDISPONIVEL: 'indisponivel',
};

/**
 * Pede ao gateway o endereço de troca `{ url }` que abre o simulador; sem análise não se monta cadeia de consulta, porque `undefined` interpolado seria aceito como identificador.
 * Nunca rejeita: o 403 vira recusa e o resto vira indisponível, com o `.catch` dentro do `trackPromise` para o indicador de carregamento encerrar.
 */
export const getBilheteDoSimulador = analise => {
  const cadeiaDeConsulta = analise ? `?analise=${encodeURIComponent(analise)}` : '';

  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/simulator/ticket${cadeiaDeConsulta}`,
      method: 'GET',
      expectToken: true,
    })
      .then(resp => resp.data)
      .then(data => ({ situacao: SITUACAO_DO_BILHETE.ABERTO, url: data.url }))
      .catch(erro => (erro?.response?.status === 403 ? { situacao: SITUACAO_DO_BILHETE.SEM_ACESSO } : { situacao: SITUACAO_DO_BILHETE.INDISPONIVEL })),
  );
};

/**
 * Renovação silenciosa: troca um bilhete novo só para regravar o cookie, com `fetch` sem seguir o redirecionamento e fora do `trackPromise` para não piscar o carregamento.
 * A falha é engolida de propósito: o cookie antigo ainda vale e a próxima renovação tenta de novo.
 */
export const renovarSessaoDoSimulador = url => fetch(url, { credentials: 'include', redirect: 'manual' }).catch(() => undefined);
